'use strict';
var isObject = require('../internals/is-object');

module.exports = function (argument) {
  return isObject(argument) || argument === null;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@twilio/conversations/node_modules/core-js/internals/is-possible-prototype.js
// module id = 5243
// module chunks = 25